import { ReactElement } from 'react';
import { useMediaQuery } from '@mui/material';

import { Table } from 'modules/common/components/Table';
import { useTranslation } from 'modules/i18n';
import { IPoolUnstake } from 'modules/pool/types';

import { ClaimRow } from '../ClaimRow';
import { translation } from './translation';
import { useStyles } from './useStyles';

interface IClaimTableProps {
  className?: string;
  rowClassName?: string;
  pendingUnstakes: IPoolUnstake[];
}

export function ClaimTable({
  className,
  pendingUnstakes,
  rowClassName,
}: IClaimTableProps): ReactElement {
  const { t, keys } = useTranslation(translation);
  const { classes, cx, theme } = useStyles();

  const isMd = useMediaQuery(theme.breakpoints.down('md'));

  const mergedRowClassName = cx(
    classes.row,
    !isMd && classes.hidePoolName,
    rowClassName,
  );

  return (
    <div className={className}>
      <Table>
        <Table.Head>
          <Table.Row className={mergedRowClassName}>
            <Table.HeadCell>{t(keys.withdrawalAmount)}</Table.HeadCell>

            <Table.HeadCell>{t(keys.initiated)}</Table.HeadCell>
          </Table.Row>
        </Table.Head>

        <Table.Body className={classes.body}>
          {pendingUnstakes.map(unstake => (
            <ClaimRow
              key={unstake.id}
              className={mergedRowClassName}
              isHidePoolName={!isMd}
              poolUnstake={unstake}
            />
          ))}
        </Table.Body>
      </Table>
    </div>
  );
}
